import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { MessageSquare, Lock, StickyNote } from "lucide-react";

export function NotesCell({ text, lastNote, onSave, canEdit, testid }) {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(text || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await onSave(val); setOpen(false); } finally { setSaving(false); }
  };

  return (
    <div className="max-w-[240px] min-w-[160px]" onClick={(e) => e.stopPropagation()} data-testid={testid}>
      <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) setVal(text || ""); }}>
        <PopoverTrigger asChild disabled={!canEdit}>
          <button type="button" title={text || ""} data-testid={`${testid}-edit`}
            className={`w-full text-left rounded px-1.5 py-1 -mx-1.5 text-xs transition-colors ${canEdit ? "hover:bg-secondary" : "cursor-default"}`}>
            {text ? (
              <span className="line-clamp-2 whitespace-pre-line">{text}</span>
            ) : (
              <span className="italic text-muted-foreground inline-flex items-center gap-1"><StickyNote className="h-3 w-3" />{canEdit ? "Notiz hinzufügen" : "—"}</span>
            )}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-80 space-y-2" align="start">
          <Textarea rows={5} value={val} onChange={(e) => setVal(e.target.value)} autoFocus data-testid={`${testid}-textarea`} />
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="outline" onClick={() => setOpen(false)}>Abbrechen</Button>
            <Button size="sm" onClick={save} disabled={saving} data-testid={`${testid}-save`}>{saving ? "Speichert…" : "Speichern"}</Button>
          </div>
        </PopoverContent>
      </Popover>
      {lastNote && (
        <div className="mt-1 text-[10px] text-muted-foreground flex items-start gap-1" title={lastNote.body} data-testid={`${testid}-last`}>
          {lastNote.internal ? <Lock className="h-3 w-3 shrink-0 mt-px" /> : <MessageSquare className="h-3 w-3 shrink-0 mt-px" />}
          <span className="line-clamp-2"><span className="font-medium">{lastNote.user_name}:</span> {lastNote.body}</span>
        </div>
      )}
    </div>
  );
}
